import React, { useState, useEffect } from 'react';
import api from '../api';
import Answer from "./Answer";
import { useParams } from 'react-router-dom';
import Lottie from 'react-lottie-player'
import successImage from '../animations/success.json';
import Loader from './Loader';

export default function Answers({user}){
    const [interview, setInterview] = useState(null);
    const [questions, setQuestions] = useState([]);
    const { jobId } = useParams();
    const [err, setErr] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState('answers');

    const submitAnswers = () => {
        setErr(null);
        const hasEmptyField = questions.find((question) => {
            return !question.answer;
        })
        if(hasEmptyField) {
            setErr('Please fill all the answers before submitting');
            return
        }else{
            setLoading(true);
            const d = {
                interview_id: interview.id,
                job_title: interview.job_title,
                job_description: interview.job_description,
                questions: questions,
                token: user.token
            }
            api.evaluateCandidate(d)
            .then(({data}) => {
                if(data.status === 'SUCCESS'){
                    window.location.href = `/evaluation/${data.data}`
                }else{
                    setErr('An error occured. Please try again later');
                }
            })
            .catch((e) => {
                setErr('An error occured. Please try again later');
                console.log(e);
            })
            .finally(() => setLoading(false))
        }
    };
    const setAnswer = (question_id, newValue) => {
        const updated = questions.map((question) => {
            if (question.id === question_id) {
                question.answer = newValue;
            }
            return question;
        });
        setQuestions(updated);
    }
    useEffect(() => {
        if (!interview) return

        const res = interview.questions.map((question) => {
            return {
                ...question,
                skills: question.skills.map((skill) => skill.text),
                answer: ""
            }
        })
        setQuestions(res);
    }, [interview])
    useEffect(() => {
        if(!user) return;

        api.getInterview(jobId, user.token)
        .then(({data}) => {
            if(data.status === 'SUCCESS'){
                if (data.data === 'locked') {
                    setPage('success');
                } else {
                    setInterview(data.data[0]);
                }
            }else{
                throw new Error(data.data);
            }
        })
        .catch((e) => {
            console.error(e);
        })
    }, [user, jobId])
    return(
        <div className='page'>
            { interview && 
                <>
                    {page === 'answers' && 
                        <div>
                            <h3 className='text__primary text__center'>
                                Interview for the <b>{interview.job_title}</b> position
                            </h3>
                            <div className="card card__rounded">
                                {interview.questions.map((dt, index) => (
                                    <div key={`answer_${index}`} >
                                        <Answer data={dt} setAnswer={setAnswer} index={index} />
                                    </div>
                                ))}
                            </div>
                            {err &&
                                <div style={{ color: 'red' }}>
                                    {err}
                                </div>
                            }
                            <button disabled={loading} onClick={submitAnswers} className="btn btn__primary btn__rounded btn__100">
                                Submit Answers
                            </button>
                        </div>
                    }
                </>
            }
            {page === 'success' &&
                <div className="card card__rounded text__center">
                    <Lottie
                        loop
                        animationData={successImage}
                        play
                        style={{ width: 250, height: 250, margin: 'auto' }}
                    />
                    <h4>Thank you for taking the time to answer our questions. We will contact you shortly for the next steps.</h4>
                </div>
            }
            {loading && <Loader />}
        </div>
    )
}